export const formatDSPName = (name: string): string => {
    return name
      .replace(/_/g, " ") // `_` ko space se replace karega
      .replace(/\b\w/g, char => char.toUpperCase()); // Har word ka first letter uppercase karega
  };
  